<template>
  <div class="seas-40">
    <div class="banner">
      <img src="https://img.kakaclo.com/web-img/home/40seas/bg_img.png" alt="">
      <div class="box">
        <div class="title">{{ $t('Seas40.Banner.Title1') }}</div>
        <div>{{ $t('Seas40.Banner.Text1') }}</div>
        <el-button :loading="loading" class="btn" type="primary" @click="payment40SeasBuyerCreditline">{{ $t('Seas40.Banner.ApplyNow') }}</el-button>
      </div>
    </div>
    <div class="module1">
      <div class="box f-b">
        <div>
          <img src="https://img.kakaclo.com/web-img/home/40seas/icon1.png" alt="">
          <div class="name">{{ $t('Seas40.Module1.Title1') }}</div>
          <!-- <div class="text">{{ $t('Seas40.Module1.Text1') }}</div> -->
          <div v-if="language === 'es'" class="text">Aplaza los pagos hasta<span class="green">90 días,</span>sin sacar un préstamo.</div>
          <div v-else class="text">Defer payments by up to<span class="green">90 days,</span>without taking out a loan.</div>
        </div>
        <div>
          <img src="https://img.kakaclo.com/web-img/home/40seas/icon2.png" alt="">
          <div class="name">{{ $t('Seas40.Module1.Title2') }}</div>
          <div class="text">{{ $t('Seas40.Module1.Text2') }}</div>
        </div>
        <div>
          <img src="https://img.kakaclo.com/web-img/home/40seas/icon3.png" alt="">
          <div class="name">{{ $t('Seas40.Module1.Title3') }}</div>
          <div class="text">{{ $t('Seas40.Module1.Text3') }}</div>
        </div>
        <div>
          <img src="https://img.kakaclo.com/web-img/home/40seas/icon4.png" alt="">
          <div class="name">{{ $t('Seas40.Module1.Title4') }}</div>
          <!-- <div class="text">{{ $t('Seas40.Module1.Text4') }}</div> -->
          <div v-if="language === 'es'" class="text">Asegure un límite de crédito de<span class="green">hasta $ 1 millón.</span></div>
          <div v-else class="text">Secure<span class="green">up to $1 Million</span>credit limit.</div>
        </div>
      </div>
    </div>
    <div class="module2">
      <div class="head f-c-c fd-c">
        <div class="title">
          <img src="https://img.kakaclo.com/web-img/home/40seas/icon5.png" alt="">
          <div>{{ $t('Seas40.Module2.Title1') }}</div>
        </div>
        <div class="text">{{ $t('Seas40.Module2.Text1') }}</div>
      </div>
      <div class="box f-b">
        <div class="left">
          <img src="https://img.kakaclo.com/web-img/home/40seas/img1.png" alt="">
        </div>
        <div class="right">
          <div class="title">{{ $t('Seas40.Module2.Title2') }}</div>
          <div class="item f--c">
            <i>1</i>
            <div>{{ $t('Seas40.Module2.Text2') }}</div>
          </div>
          <div class="item f--c">
            <i>2</i>
            <div>{{ $t('Seas40.Module2.Text3') }}</div>
          </div>
          <div class="item f--c">
            <i>3</i>
            <div>{{ $t('Seas40.Module2.Text4') }}</div>
          </div>
          <div class="item f--c">
            <i>4</i>
            <div>{{ $t('Seas40.Module2.Text5') }}</div>
          </div>
          <div class="item f--c">
            <i>5</i>
            <div>{{ $t('Seas40.Module2.Text6') }}</div>
          </div>
          <div class="item f--c">
            <i>6</i>
            <div>{{ $t('Seas40.Module2.Text7') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module3">
      <div class="box f-b">
        <div class="left">
          <div class="title">{{ $t('Seas40.Module3.Title1') }}</div>
          <div class="item f--c">
            <i>1</i>
            <div>{{ $t('Seas40.Module3.Text1') }}</div>
          </div>
          <div class="item f--c">
            <i>2</i>
            <div>{{ $t('Seas40.Module3.Text2') }}</div>
          </div>
          <div class="item f--c">
            <i>3</i>
            <!-- <div>{{ $t('Seas40.Module3.Text3') }}</div> -->
            <div v-if="language === 'es'">El monto del pedido debe ser<span class="green">superior a $ 2000</span>para ser elegible para su uso.</div>
            <div v-else>The order amount must be<span class="green">higher than $2000</span>to be eligible for use.</div>
          </div>
          <div class="item f--c">
            <i>4</i>
            <!-- <div>{{ $t('Seas40.Module3.Text4') }}</div> -->
            <div v-if="language === 'es'"><span class="green" style="padding-left:0;">Los pedidos pagados con el límite de crédito no admiten reembolsos después del envío.</span>Sin embargo, puede devolver el límite de crédito antes del envío.</div>
            <div v-else><span class="green" style="padding-left:0;">Orders paid with credit limit do not support refunds after shipment.</span>However, you can return the credit limit before shipment.</div>
          </div>
        </div>
        <div class="right">
          <img src="https://img.kakaclo.com/web-img/home/40seas/img2.png" alt="">
        </div>
      </div>
      <div class="box" style="margin-top:160px;">
        <div class="title" style="text-align:center;">{{ $t('Seas40.Module3.Title2') }}</div>
        <div class="questions">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('Seas40.Module3.Text5')" name="1">
              <div class="text">{{ $t('Seas40.Module3.Text6') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Seas40.Module3.Text7')" name="2">
              <!-- <div class="text">{{ $t('Seas40.Module3.Text8') }}</div> -->
              <div v-if="language === 'es'" class="text">El límite de crédito disponible varía para cada individuo.<span class="green">El límite máximo es de $1 millón,</span>sujeto al resultado final de la aprobación.</div>
              <div v-else class="text">The available credit limit varies for each individual.<span class="green">The maximum limit is $1 million,</span>subject to the final approval result.</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Seas40.Module3.Text9')" name="3">
              <!-- <div class="text">{{ $t('Seas40.Module3.Text10') }}.</div> -->
              <div v-if="language === 'es'" class="text">Para usar el límite de crédito para el pago, el monto del pedido debe ser<span class="green">superior a $2,000.</span></div>
              <div v-else class="text">To use the credit limit for payment, the order amount must be<span class="green">higher than $2,000.</span></div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Seas40.Module3.Text11')" name="4">
              <div class="text">{{ $t('Seas40.Module3.Text12') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Seas40.Module3.Text13')" name="5">
              <div class="text">{{ $t('Seas40.Module3.Text14') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Seas40.Module3.Text15')" name="6">
              <div class="text">{{ $t('Seas40.Module3.Text16') }}</div>
              <img class="img" src="https://img.kakaclo.com/web-img/home/40seas/img3.png" alt="">
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="box" style="margin-top:120px;">
        <img class="bg" src="https://img.kakaclo.com/web-img/home/40seas/img4.png" alt="">
        <div class="content f-c-c fd-c">
          <!-- <div class="title">Join the 40Seas community</div> -->
          <!-- <div v-if="language === 'es'" class="title">Únase a la comunidad <span class="green">40Seas</span></div>
          <div v-else class="title">Join the <span class="green">40Seas </span>community</div> -->
          <div class="text">{{ $t('Seas40.Module3.Text18') }}</div>
          <el-button class="btn" type="primary" @click="payment40SeasBuyerCreditline">{{ $t('Seas40.Banner.ApplyNow') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      activeNames: [],
      loading: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  methods: {
    applyNow() {
      this.loading = true
      API.payment40SeasBuyer().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        // window.open(res.data.url)
        window._40Seas.open(res.data.token, {
          onCancel: (payload) => {
            // console.log('User closed the modal at page ' + payload.page)
            window._40Seas.close()
          }
        })
      }).finally(() => {
        this.loading = false
      })
    },

    // 40seas-获取用户信用额度
    payment40SeasBuyerCreditline() {
      API.payment40SeasBuyerCreditline().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.info40Seas = res.data || {}
        if (this.info40Seas.status === 'approved') {
          this.$router.push('/personal-center/payment-manage')
        } else this.applyNow()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.green {
  color: #9AC331;
  padding: 0 6px;
}
.seas-40{
  min-width: 1300px;
  background-color: #fff;
  font-family: 'Poppins';
  .banner{
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .box {
      position: absolute;
      top: 31%;
      left: 12%;
      color: #fff;
      font-size: 24px;

      .title {
        font-size: 56px;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .btn {
        margin-top: 40px;
        font-size: 18px;
        line-height: 18px;
        padding: 16px 30px;
      }
    }
  }
  .module1, .module2, .module3{
    >.box {
      margin: 0 auto;
    }
  }

  .module1 {
    padding: 80px 40px 150px 40px;

    .box {
      min-width: 1200px;
      max-width: 1500px;
      >div {
        width:24%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 10px;

        img {
          width: 136px;
          height: 136px;
        }

        .name {
          font-size: 28px;
          font-weight: bold;
          color: #303133;
          margin: 12px 0;
        }

        .text {
          font-size: 16px;
          color: #909399;
          text-align: center;
          font-weight: 400;
        }
      }
    }
  }

  .module2 {
    background: linear-gradient(90deg, rgba(68,255,244,0.1) 0%, rgba(139,255,68,0.1) 100%);
    padding: 140px 0 80px;

    .head {
      margin: 0 auto;
      .title {
        color: #303133;
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 24px;
        position: relative;
        height: 60px;
        width: 700px;
        white-space:nowrap;
        >img {
          width: 164px;
          position: absolute;
          top: -20px;
        }
        >div {
          position: absolute;
          z-index: 1;
          width: 100%;
          text-align: center;
        }
      }
      .text {
        color: #606266;
        font-size: 18px;
        width: 940px;
        text-align: center;
        font-weight: 400;
      }
    }
    .box {
      margin-top: 160px;
      width: 80%;
      .left {
        width: 50%;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }

      .right {
        width: 40%;

        .title {
          font-size: 36px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 64px;
        }

        .item {
          margin-bottom: 40px;
          i {
            font-style: unset;
            width: 48px;
            height: 48px;
            background-color: #9AC331;
            color: #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            flex-shrink: 0;
            margin-right: 24px;
          }
          >div {
            font-size: 18px;
            color: #606266;
          }
        }
      }
    }
  }

  .module3 {
    padding: 120px 40px;

    .box {
      width: 80%;
      position: relative;

      .title {
        font-size: 36px;
        color: #303133;
        font-weight: bold;
        margin-bottom: 64px;
      }

      .left {
        width: 50%;
        .item {
          margin-bottom: 40px;
          i {
            font-style: unset;
            width: 48px;
            height: 48px;
            background-color: #FAB55A;
            color: #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            flex-shrink: 0;
            margin-right: 24px;
          }
          >div {
            font-size: 18px;
            color: #606266;
          }
        }
      }
      .right {
        width: 40%;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }

      .text {
        font-size: 18px;
        font-weight: 40px;
        color: #606266;
      }

      .questions {
        width: 85%;
        margin: 0 auto;
        margin-top: 64px;

        /deep/ .el-collapse {
          border-top: 0;

          .el-collapse-item__header {
            height: 80px;
            line-height: 80px;
            font-size: 24px;
            color: #303133;
          }

          .text {
            padding: 14px 60px 10px 0;
            font-size: 18px;
            color: #606266;
            font-weight: 400;
          }

          .img {
            width: 460px;
            margin-top: 10px;
          }
        }
      }

      .bg {
        width: 100%;
        display: block;
      }

      .content {
        position: absolute;
        width: 82%;
        height: 230px;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        text-align: center;

        .title {
          margin-bottom: 24px;
          padding-top: 6px;
        }

        .btn {
          margin-top: 40px;
          font-size: 16px;
          padding: 14px 22px;
        }
      }
    }
  }
}
</style>
